import { StructuredText } from "datocms-structured-text-utils"
import React, { useLayoutEffect, useState } from "react"

import { getArticleHeaderHeight } from "../../../shared-components/article-heading"
import { CmsArticleContent } from "../../../shared-components/cms-article-content"
import useBreakpoint from "../../../utils/hooks/use-breakpoint"
import useWindowSize from "../../../utils/hooks/use-window-size"
import BlogTableOfContents from "../blog-table-of-contents"
import SidebarNewsletterCta from "../blog-table-of-contents/sidebar-newsletter-cta"
import * as styles from "./index.module.scss"

export type BlogPostContentProps = {
  body: StructuredText
  articleHeader: React.ReactNode
}

const DEFAULT_TOP_OFFSET = 582 // Approximation, since this can't be calculated on the server side. Title two lines tall in a large screen normally results in this offset

const BlogPostContent = ({ body, articleHeader }: BlogPostContentProps) => {
  const [top, setTop] = useState(DEFAULT_TOP_OFFSET)
  const { isSmallBreakpoint } = useBreakpoint()
  const { width } = useWindowSize()
  useLayoutEffect(() => {
    setTop(getArticleHeaderHeight())
  }, [width])

  return (
    <section className={styles.container}>
      <div className={styles.sideSpace}>
        <div style={{ height: `${top}px` }} />
        <div className={styles.sidebar}>
          {!isSmallBreakpoint && (
            <div className={styles.sidebarContent}>
              <BlogTableOfContents body={body} />
              <SidebarNewsletterCta />
            </div>
          )}
        </div>
      </div>
      <div className={styles.content}>
        <article>
          {articleHeader}
          <CmsArticleContent body={body} />
        </article>
        {isSmallBreakpoint && <SidebarNewsletterCta />}
      </div>
      <div className={styles.sideSpace} />
    </section>
  )
}

export default BlogPostContent
